import React from "react";
import Loader from "react-loader-spinner";

import PropTypes from "prop-types";
import { Modal } from "@mui/material";

function Loadspinner(props) {
  //console.log(`spinner from : ${props?.filename}, visible: ${props.isLoading}`);
  //if (props.isLoading) {
  if (props.isMiddle == "true")
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          zIndex: 9999,
          display: props.isLoading ? 'block' : 'none'
        }}
      >
        <Loader type="Puff" color="#00BFFF" height={100} width={100} visible={props.isLoading} />
      </div>
    );
  return (
    <Modal
      disableEnforceFocus
      disableAutoFocus
      open={props.isLoading}
      style={{ background: "transparent" }}
    >
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          zIndex: 9999
        }}
      >
        <Loader type="Puff" color="#00BFFF" height={100} width={100} />
      </div>
    </Modal>
  );
  //}

  //return null;
}

export default Loadspinner;

Loadspinner.propTypes = {
  isLoading: PropTypes.bool,
  isMiddle: PropTypes.string,
  filename: PropTypes.string,
};
